module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-106.eceedcd.woff2";